import { ButtonLink } from '@components/ui/Button'
import Translations from '@helpers/translations'
import styles from './styles.module.scss'

type QRCodeBoxProps = {
  labelUrl: string
}

function QRCodeBox({ labelUrl }: QRCodeBoxProps) {
  return (
    <div className={styles.returnsQrCode}>
      <div className={styles.returnsQrCode__container}>
        <span className={styles.returnsQrCode__title}>
          {Translations.localise('pages.returns.label-generated')}
        </span>

        {labelUrl && (
          <ButtonLink href={labelUrl} target="_blank">
            {Translations.localise('pages.returns.view-returns-label')}
          </ButtonLink>
        )}
      </div>
    </div>
  )
}

export default QRCodeBox
